/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from "react";
// import Posts from "../post/Posts";
import { Button, Form } from 'react-bootstrap';
import {
    Box,
    Button as MuiButton,
    Card,
    CardContent,
    Typography,
    Container as MuiContainer,
    Grid
} from '@mui/material';
import { Stack, Container, Chip, Divider } from "@mui/material";

import EventIcon from '@mui/icons-material/Event';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import PresentationIcon from '@mui/icons-material/Slideshow';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import Footer from './Footer';
import Schedule2026 from './Schedule2026';
import { sendMessage } from "../group/apigroup";
import moment from "moment";
import TN_IMAGE from '../images/chatanooga.PNG';
import MESA_LOGO from '../images/Mesa-Associates-Transparent.png';

import ReactPlayer from "react-player"

class publicColoradoEvent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            error: '',
            success: ''
        }
    }

    handleChange = name => event => {
        if (name === "email") {
            this.setState({ error: "" });
            this.setState({ responseTo: name, [name]: event.target.value });
        }
    };

    showError() {
        return (
            <div className="alert alert-danger" style={{ display: this.state.error ? "" : "none" }}>
                {this.state.error}
            </div>
        )
    };

    showSuccess() {
        return (
            <div className="alert alert-info" style={{ display: this.state.success ? "" : "none" }}>
                <h3>Your on the list!</h3>
                <p>Don't forget to check your inbox and your spam folder for updates from the SDSIC.</p>
                <p>We will use the email you've submitted to send you updates as we finalize the upcoming event.</p>
            </div>
        )
    };

    submitEmail = e => {
        const { email } = this.state;
        e.preventDefault();
        if (email === "") { this.setState({ error: "email required!" }) }

        if (email !== "") {
            const mailMessage = {
                to: 'trevor.scullion@automationforce.com',
                from: email,
                subject: "SDSIC 2022 FALL event list",
                Message: 'Please add ' + email + ' to the SDSIC 2022 FALL event list.',
                html: "<p>Please add " + email + " to the SDSIC 2022 FALL event list.</p>",
                dateSent: moment().format('YYYY-MM-DD[T00:00:00.000Z]')
            }
            // make request to api to send message
            sendMessage(mailMessage).then(data => {
                this.setState({
                    email: '',
                    success: true,
                });
            });

            const userMessage = {
                to: email,
                from: 'donotreply@sdsconsortium.com',
                subject: "SDSIC 2022 FALL event",
                Message: 'Your name is on the SDSIC 2022 FALL event list.',
                html: "<p>Your name is on the SDSIC 2022 FALL event list.</p><p>You will be kept up to date " +
                    "as we finalize the event details.</p><p>Please do not reply to this email.</p>",
                dateSent: moment().format('YYYY-MM-DD[T00:00:00.000Z]')
            }

            // make request to api to send message
            sendMessage(userMessage).then(data => { });
        };
    };

    whyPresent = [
        "Elevate your profile with the community shaping substation design",
        "Get real feedback from practitioners and decision-makers",
        "Build relationships that turn pilots into projects",
    ];

    whoShouldSubmit =
        "Utility engineers & designers • Protection & control • CAD/BIM/Revit leads • GIS/Esri pros • AI/ML & automation teams • Standards/compliance leaders • Construction & commissioning managers • Product engineers";

    sessionFormats = [
        { title: "Round Table (50 min)", desc: "Deep Topic discussions, strong group activity" },
        { title: "Breakout (50 min)", desc: "Case study or technical deep dive" },
        { title: "Workshop/Panel (50 min)", desc: "Hands-on, demo, or multi-perspective" },
    ];

    tracks = [
        { t: "Agentic AI & Automation", d: "real workflows, RAG, QA loops, safety guardrails" },
        { t: "Design Standards & Compliance", d: "IEEE/CSA/NESC at scale, validation pipelines" },
        { t: "Digital Twins & LiDAR", d: "scan-to-as-built, point clouds to packages" },
        { t: "Constructability & Permitting", d: "option screening, site layers, risk scoring" },
        { t: "CAD/BIM & Interop", d: "Revit, Inventor, Civil 3D, ArcGIS—clean handoffs that stick" },
        { t: "Reliability & Protection", d: "FAC-008/FAC-014, modeling, testing, telemetry" },
        { t: "Sustainability", d: "embodied carbon, OHL/UGC choices, materials intelligence" },
        { t: "Field Lessons Learned", d: "commissioning surprises, change orders avoided" },
    ];

    strongProposal = [
        "Clear problem → method → measurable impact",
        "Tools/stack named (software, standards, data sources)",
        "Specific takeaways the audience can reuse next week",
        "Speaker(s) with direct project experience",
    ];

    checklist = [
        { k: "Title", v: "8–12 words, action-oriented" },
        { k: "Abstract (150–250 words)", v: "problem, approach, results, 3 takeaways" },
        { k: "Format", v: "Lightning / Breakout / Workshop" },
        { k: "Audience level", v: "Intro / Intermediate / Advanced" },
        { k: "Speakers", v: "name, role, company, email" },
        { k: "Optional", v: "links to repo, slides, screenshots, diagrams" },
    ];


    render() {
        return (
            <>
                <div className="container-fluid">
                    <div className="row justify-content-md-center">
                        <div className="col-md-12">
                            <Box
                                component="section"
                                sx={{
                                    position: "relative",
                                    overflow: "hidden",
                                    py: { xs: 6, md: 10 },
                                    borderRadius: { xs: 0, md: 4 },
                                    background: 'linear-gradient(135deg, #003E7E 0%, #0055A5 60%, #003E7E 100%)',
                                    color: 'white',
                                }}
                            >
                                <Box sx={{
                                    position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
                                    background:
                                        'radial-gradient(1200px circle at 20% 20%, rgba(25,118,210,0.25), transparent 50%),' +
                                        'radial-gradient(900px circle at 80% 30%, rgba(156,39,176,0.12), transparent 45%)',
                                    pointerEvents: 'none',
                                }} />
                                <Container maxWidth="lg" sx={{ position: 'relative' }}>
                                    <Grid container spacing={4} alignItems="center">
                                        <Grid item xs={12} md={7}>
                                            <Stack spacing={2.25}>
                                                <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                                                    <Chip label="SDSIC" variant="outlined" sx={{ color: 'white', borderColor: 'rgba(255,255,255,0.5)' }} />
                                                    <Chip label="Spring 2026" sx={{ backgroundColor: '#FF6600', color: 'white' }} />
                                                    <Chip label="Colorado" variant="outlined" sx={{ color: 'white', borderColor: 'rgba(255,255,255,0.5)' }} />
                                                </Stack>

                                                <Typography
                                                    variant="h2"
                                                    sx={{
                                                        fontWeight: 800,
                                                        letterSpacing: -0.8,
                                                        lineHeight: 1.05,
                                                        fontSize: { xs: "2rem", sm: "2.75rem", md: "3.25rem" },
                                                    }}
                                                >
                                                    The SDSIC 2026 Conference
                                                </Typography>

                                                <Typography
                                                    variant="h5"
                                                    sx={{ lineHeight: 1.4, maxWidth: 820, fontSize: { xs: "1.05rem", md: "1.25rem" }, opacity: 0.92 }}
                                                >
                                                    We are excited to have SBS hosting this year's 2027 conference in beautiful Colorado for the very first time!
                                                </Typography>

                                                <Stack direction="row" spacing={3} alignItems="center" flexWrap="wrap" useFlexGap>
                                                    <Stack direction="row" spacing={1} alignItems="center">
                                                        <EventIcon sx={{ fontSize: 24 }} />
                                                        <Typography variant="h6" sx={{ fontWeight: 500 }}>
                                                            April 13–16, 2026 &bull; Denver, Colorado
                                                        </Typography>
                                                    </Stack>
                                                    <Stack direction="row" spacing={1} alignItems="center">
                                                        <ConfirmationNumberIcon sx={{ fontSize: 22 }} />
                                                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                                            $750 per attendee
                                                        </Typography>
                                                    </Stack>
                                                </Stack>
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} md={5} sx={{ textAlign: { xs: 'center', md: 'right' } }}>
                                            <MuiButton
                                                variant="contained"
                                                size="large"
                                                href="https://reg26.sdsconsortium.com/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                endIcon={<OpenInNewIcon />}
                                                sx={{
                                                    backgroundColor: '#FF6600',
                                                    color: 'white',
                                                    fontSize: '1.25rem',
                                                    fontWeight: 600,
                                                    py: 2,
                                                    px: 4,
                                                    borderRadius: 2,
                                                    textTransform: 'none',
                                                    boxShadow: '0 8px 16px rgba(255, 102, 0, 0.3)',
                                                    '&:hover': {
                                                        backgroundColor: '#e55a00',
                                                        transform: 'translateY(-2px)',
                                                        boxShadow: '0 12px 20px rgba(255, 102, 0, 0.4)',
                                                    },
                                                    transition: 'all 0.3s ease'
                                                }}
                                            >
                                                Get Tickets
                                            </MuiButton>
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    display: 'block',
                                                    mt: 1.5,
                                                    opacity: 0.9,
                                                    fontSize: '0.875rem'
                                                }}
                                            >
                                                Secure registration opens in new tab
                                            </Typography>
                                            <Typography variant="body2" sx={{ mt: 2, opacity: 0.8 }}>
                                                Don't miss the only face-to-face meeting in 2026!
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Container>
                            </Box>

                            <main role="main" className="container-fluid d-flex flex-column align-items-center justify-content-center min-vh-50 py-5">

                                {/* Presentation Proposal Section - MUI */}
                                <Box sx={{ mb: 6, width: '100%' }}>
                                    <MuiContainer maxWidth="md">
                                        <Card
                                            elevation={4}
                                            sx={{
                                                background: 'linear-gradient(135deg, #FF6600 0%, #FF8533 100%)',
                                                color: 'white',
                                                borderRadius: 3,
                                                overflow: 'visible'
                                            }}
                                        >

                                        </Card>
                                    </MuiContainer>
                                </Box>

                                {/* Conference Schedule Section */}
                                <Schedule2026 />

                                <hr className="w-100" />

                                {/* Social Media Section - MUI */}
                                <Box sx={{ my: 6, width: '100%' }}>
                                    <MuiContainer maxWidth="sm">

                                        <Box sx={{ textAlign: 'center', mb: 4 }}>
                                            <Typography variant="h4" sx={{ fontWeight: 700, mb: 1.5, color: '#003E7E' }}>
                                                Stay Connected
                                            </Typography>
                                            <Typography variant="body1" color="text.secondary">
                                                Follow us on social media for updates and announcements
                                            </Typography>
                                        </Box>
                                        <Card
                                            elevation={4}
                                            sx={{
                                                background: 'linear-gradient(135deg, #003E7E 0%, #0055A5 100%)',
                                                color: 'white',
                                                borderRadius: 3,
                                                overflow: 'visible'
                                            }}
                                        >
                                            <CardContent sx={{ p: 5 }}>
                                                <Grid container spacing={3} justifyContent="center">
                                                    <Grid item xs={12} sm={6}>
                                                        <Card
                                                            elevation={3}
                                                            sx={{
                                                                backgroundColor: '#0077B5',
                                                                borderRadius: 3,
                                                                transition: 'all 0.3s ease',
                                                                cursor: 'pointer',
                                                                '&:hover': {
                                                                    backgroundColor: '#005885',
                                                                    transform: 'translateY(-8px)',
                                                                    boxShadow: '0 12px 24px rgba(0, 119, 181, 0.4)',
                                                                }
                                                            }}
                                                            component="a"
                                                            href="https://www.linkedin.com/company/sds-industry-consortium"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            <CardContent sx={{ p: 4, textAlign: 'center' }}>
                                                                <LinkedInIcon sx={{ fontSize: 56, mb: 2, color: '#fff' }} />
                                                                <Typography variant="h5" sx={{ fontWeight: 600, mb: 1, color: '#fff' }}>
                                                                    LinkedIn
                                                                </Typography>
                                                                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
                                                                    Professional updates & industry insights
                                                                </Typography>
                                                            </CardContent>
                                                        </Card>
                                                    </Grid>

                                                    <Grid item xs={12} sm={6}>
                                                        <Card
                                                            elevation={3}
                                                            sx={{
                                                                backgroundColor: '#E4405F',
                                                                borderRadius: 3,
                                                                transition: 'all 0.3s ease',
                                                                cursor: 'pointer',
                                                                '&:hover': {
                                                                    backgroundColor: '#C13584',
                                                                    transform: 'translateY(-8px)',
                                                                    boxShadow: '0 12px 24px rgba(228, 64, 95, 0.4)',
                                                                }
                                                            }}
                                                            component="a"
                                                            href="https://www.instagram.com/sdsic2026/"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            <CardContent sx={{ p: 4, textAlign: 'center' }}>
                                                                <InstagramIcon sx={{ fontSize: 56, mb: 2, color: '#fff' }} />
                                                                <Typography variant="h5" sx={{ fontWeight: 600, mb: 1, color: '#fff' }}>
                                                                    Instagram
                                                                </Typography>
                                                                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
                                                                    Event photos & behind-the-scenes
                                                                </Typography>
                                                            </CardContent>
                                                        </Card>
                                                    </Grid>

                                                </Grid>

                                            </CardContent>
                                        </Card>
                                    </MuiContainer>
                                </Box>

                                <hr className="w-100 mt-5" />

                            </main>
                        </div>
                    </div >
                </div >
                <br />
                <br />
                <Footer />
            </>
        )
    }
}

export default publicColoradoEvent